import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useRouter } from "next/router";

// Two audience segments for the landing page. Each tab is a separate
// route so the content is independently linkable and indexable.
const audiences: { label: string; href: string }[] = [
  // { label: "For Language Learners", href: "/" },
  // { label: "For Content Creators", href: "/for-creators" },
];

type AudienceTabsProps = {
  /** Currently active tab index (0 = learners, 1 = creators). */
  activeIndex: number;
};

export const AudienceTabs = ({ activeIndex }: AudienceTabsProps) => {
  const router = useRouter();

  if (audiences.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 6, mb: 4 }}>
      <Tabs
        value={activeIndex}
        onChange={(_event, newValue) => {
          router.push(audiences[newValue].href);
        }}
        variant="fullWidth"
        aria-label="Audience"
      >
        {audiences.map(({ label }) => (
          <Tab
            key={label}
            label={label}
            sx={{ fontSize: "1.1rem", py: 2, px: 4, whiteSpace: "nowrap" }}
          />
        ))}
      </Tabs>
    </Box>
  );
};
